import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// =====================================================
// API CONFIG
// =====================================================
const API_BASE =
  process.env.REACT_APP_API_URL ||
  "https://eduadmin.sindoor7.com";

const PROFILE_ENDPOINT =
  `${API_BASE}front-website-parent-profile`;

const CHILDREN_ENDPOINT =
  `${API_BASE}front-website-parent-children`;

// =====================================================
// MENU
// =====================================================
const MENU = [
  ["/Parentdashboard", "fa-tachometer", "Dashboard"],
  ["/profile", "fa-user", "My Profile", "active"],
  // ["/Student_Report_Dashbord", "fa-users", "Students"],
];

export default function Profile() {
  const [open, setOpen] = useState(false);
  const [dark, setDark] = useState(false);
  const [edit, setEdit] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Children
  const [children, setChildren] = useState([]);
  const [loadingKids, setLoadingKids] = useState(true);
  const [kidsError, setKidsError] = useState("");

  const [p, setP] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    school: "",
    city: "",
    joiningDate: "",
  });

  const [t, setT] = useState(p);

  // =====================================================
  // FETCH PARENT PROFILE
  // =====================================================
  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      setError("");

      try {
        const storage =
          localStorage.getItem("parent_id") ||
          sessionStorage.getItem("parent_id") ||
          localStorage.getItem("student_id") ||
          sessionStorage.getItem("student_id");

        const id = storage ? Number(storage) : null;

        if (!id) {
          throw new Error("User ID not found. Please login again.");
        }

        const res = await fetch(PROFILE_ENDPOINT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id }),
        });

        const data = await res.json().catch(() => ({}));
        console.log("Profile Response:", data);

        if (!res.ok || data?.status !== 1 || !data?.data) {
          throw new Error(data?.message || "Failed to load profile.");
        }

        const d = data.data;

        const roleMap = {
          1: "Super Admin",
          2: "Admin",
          3: "Staff",
          4: "Teacher",
          5: "Parent",
          6: "Student",
        };

        const profile = {
          name: d.name || "-",
          email: d.email || "-",
          phone: d.phone || "-",
          role: roleMap[d.roles] || "Parent",
          school: d.school_name || `School ID: ${d.school_id || "-"}`,
          city: d.city || "-",
          joiningDate: d.created_at
            ? new Date(d.created_at).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "-",
        };

        setP(profile);
        setT(profile);

        const target = localStorage.getItem("parent_id")
          ? localStorage
          : sessionStorage;
        target.setItem("parent", JSON.stringify(d));
      } catch (err) {
        console.error("Profile Error:", err);
        setError(err?.message || "Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  // =====================================================
  // FETCH CHILDREN
  // =====================================================
  useEffect(() => {
    const fetchChildren = async () => {
      setLoadingKids(true);
      setKidsError("");

      try {
        const storage =
          localStorage.getItem("parent_id") ||
          sessionStorage.getItem("parent_id") ||
          localStorage.getItem("student_id") ||
          sessionStorage.getItem("student_id");

        const id = storage ? Number(storage) : null;

        if (!id) {
          throw new Error("User ID not found.");
        }

        const res = await fetch(CHILDREN_ENDPOINT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id }),
        });

        const data = await res.json().catch(() => ({}));
        console.log("Children Response:", data);

        if (!res.ok || data?.status !== 1) {
          throw new Error(data?.message || "Failed to load children.");
        }

        // Accept either data.children, data.data, or data itself as array
        const list =
          data?.children ||
          data?.data ||
          (Array.isArray(data) ? data : []);

        const mapped = (Array.isArray(list) ? list : []).map((c) => ({
          id: c.id ?? c.student_id ?? c.stu_id,
          name: c.name ?? c.student_name ?? c.full_name ?? "-",
          cls:
            c.class_name ??
            c.class ??
            c.standard ??
            c.grade ??
            c.class_id ??
            "-",
          section: c.section ?? c.sec ?? "",
          roll: c.roll_no ?? c.roll ?? c.roll_number ?? "-",
          gender: c.gender ?? c.sex ?? "-",
          photo: c.photo ?? c.image ?? c.profile_image ?? "",
          school: c.school_name ?? c.school ?? "",
          status: c.status === 1 || c.status === "1" || c.status === "Active"
            ? "Active"
            : "Inactive",
        }));

        setChildren(mapped);
      } catch (err) {
        console.error("Children Error:", err);
        setKidsError(err?.message || "Failed to load children.");
      } finally {
        setLoadingKids(false);
      }
    };

    fetchChildren();
  }, []);

  const ch = (e) => setT({ ...t, [e.target.name]: e.target.value });
  const save = () => {
    setP(t);
    setEdit(false);
  };
  const cancel = () => {
    setT(p);
    setEdit(false);
  };

  const F = ({ i, l, n, v, full, dis }) => (
    <div className="fld" style={full ? { gridColumn: "span 2" } : {}}>
      <i className={`fa ${i} fi`} />
      <div className="fb">
        <label>{l}</label>
        {edit && !dis ? (
          <input name={n} value={v} onChange={ch} className="fip" />
        ) : (
          <p>{v || "-"}</p>
        )}
      </div>
    </div>
  );

  return (
    <>
      <style>{`
/* =====================================================
   GLOBAL
===================================================== */
:root {
  --bg: #f4f7fb;
  --c: #fff;
  --tx: #163a59;
  --mu: #64748b;
  --bd: #e4ecf5;
  --b: #2563eb;
  --p: #7c3aed;
  --g: #10b981;
  --r: #ef4444;
  --o: #f59e0b;
  --sh: 0 8px 28px rgba(8,35,60,.08);
}
.dk {
  --bg: #0b1220;
  --c: #131c31;
  --tx: #e2e8f0;
  --mu: #94a3b8;
  --bd: #1f2b45;
}
* { box-sizing: border-box; font-family: Inter, "Segoe UI", Arial, sans-serif; }
html, body, #root { width: 100%; min-height: 100%; margin: 0; }
body { overflow-x: hidden; }

/* MAIN WRAPPER */
.pw { width: 100%; min-height: 100vh; background: var(--bg); color: var(--tx); padding-bottom: 40px; }
.lay {
  width: 100%; max-width: 1600px; min-height: 100vh; margin: 0 auto;
  padding: 22px 30px; display: flex; align-items: flex-start; gap: 22px;
}

/* SIDEBAR */
.sb {
  position: sticky; top: 20px;
  width: 250px; min-width: 250px; flex: 0 0 250px;
  background: var(--c); border: 1px solid var(--bd); border-radius: 16px;
  padding: 16px 12px; box-shadow: var(--sh);
}
.br { display: flex; align-items: center; gap: 11px; padding: 6px 8px 16px; margin-bottom: 10px; border-bottom: 1px solid var(--bd); }
.bi {
  width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, rgba(37,99,235,.12), rgba(124,58,237,.10));
  border-radius: 11px; color: var(--b); font-size: 17px;
}
.br small { display: block; color: var(--b); font-size: 9px; font-weight: 800; letter-spacing: 1.4px; }
.br strong { font-size: 16px; font-weight: 800; }
.mn { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 3px; }
.mn a {
  display: flex; align-items: center; gap: 14px; padding: 11px 14px;
  color: var(--tx); font-size: 14px; font-weight: 600; text-decoration: none;
  border-radius: 10px; border: 1px solid transparent; transition: .25s;
}
.mn a i { width: 20px; text-align: center; color: #4b5a6b; }
.mn a:hover { background: #f8fafc; color: var(--b); transform: translateX(3px); }
.mn a.active {
  background: linear-gradient(135deg, rgba(37,99,235,.10), rgba(124,58,237,.08));
  color: var(--b); border-color: rgba(37,99,235,.15);
}
.dv { height: 2px; margin: 12px 4px; background: linear-gradient(90deg, transparent, var(--r), transparent); border-radius: 20px; opacity: .7; }

/* MAIN */
.mn2 { flex: 1; min-width: 0; width: 100%; }

/* TOP BAR */
.tb {
  width: 100%; display: flex; align-items: center; gap: 16px;
  margin-bottom: 22px; margin-top: 20px; padding: 18px 24px;
  background: var(--c); border: 1px solid var(--bd); border-radius: 16px; box-shadow: var(--sh);
}
.mb {
  display: none; width: 42px; height: 42px; flex-shrink: 0;
  align-items: center; justify-content: center;
  background: linear-gradient(135deg, var(--b), var(--p));
  border: none; border-radius: 11px; color: #fff; cursor: pointer;
}
.tt { flex: 1; min-width: 0; }
.tt h1 { margin: 0; font-size: 22px; font-weight: 800; }
.tt p { margin: 4px 0 0; color: var(--mu); font-size: 13px; }
.ta { display: flex; align-items: center; gap: 12px; flex-shrink: 0; }
.ib {
  position: relative; width: 42px; height: 42px;
  background: #f8fafc; border: 1px solid var(--bd); border-radius: 11px;
  color: var(--tx); cursor: pointer;
}
.ib:hover { background: #eef2ff; color: var(--b); }
.dt {
  position: absolute; top: 9px; right: 10px;
  width: 8px; height: 8px; border-radius: 50%;
  background: var(--r); border: 2px solid var(--c);
}
.as {
  width: 42px; height: 42px; flex-shrink: 0; border-radius: 50%;
  background: linear-gradient(135deg, var(--b), var(--p));
  color: #fff; display: flex; align-items: center; justify-content: center; font-weight: 800;
}

/* OVERLAY */
.ov { position: fixed; inset: 0; background: rgba(1,11,23,.55); z-index: 998; }

/* DETAILS */
.dc {
  width: 100%; background: var(--c); border: 1px solid var(--bd);
  border-radius: 16px; box-shadow: var(--sh); padding: 24px; margin-bottom: 20px;
}
.dh {
  display: flex; justify-content: space-between; align-items: center;
  gap: 16px; flex-wrap: wrap; margin-bottom: 22px;
}
.dh h3 { margin: 0; font-size: 17px; font-weight: 800; }
.dh p { margin: 4px 0 0; color: var(--mu); font-size: 12.5px; }
.da { display: flex; gap: 8px; }
.bc, .bs {
  display: flex; align-items: center; justify-content: center; gap: 7px;
  padding: 9px 16px; border-radius: 10px;
  font-size: 13px; font-weight: 700; cursor: pointer;
}
.bc { background: #f8fafc; color: var(--tx); border: 1px solid var(--bd); }
.bc:hover { background: #fee2e2; color: #b91c1c; }
.bs { border: none; background: linear-gradient(135deg, var(--b), var(--p)); color: #fff; }

/* GRID */
.gd { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
.fld {
  min-width: 0; display: flex; align-items: flex-start; gap: 12px;
  padding: 16px 18px; border: 1px solid var(--bd); border-radius: 12px;
  background: #f8fafc; transition: all .25s ease;
}
.fld:hover {
  transform: translateY(-4px); border-color: var(--b); background: #fff;
  box-shadow: 0 10px 22px rgba(37,99,235,.12);
}
.fi {
  width: 36px; height: 36px; flex: 0 0 36px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 9px; background: #eef2ff; color: var(--b); font-size: 14px;
}
.fb { flex: 1; min-width: 0; }
.fb label {
  display: block; margin-bottom: 5px; color: var(--mu);
  font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px;
}
.fb p { margin: 0; font-size: 14.5px; font-weight: 600; overflow-wrap: anywhere; word-break: break-word; }
.fip {
  width: 100%; max-width: 100%; height: 34px; padding: 0 10px;
  border: 1px solid var(--bd); border-radius: 8px;
  font-size: 13.5px; color: var(--tx); outline: none;
}
.fip:focus { border-color: var(--b); box-shadow: 0 0 0 3px rgba(37,99,235,.10); }

/* DIVIDER */
.cd {
  height: 2px; margin: 24px 0 20px;
  background: linear-gradient(90deg, transparent, var(--r), transparent);
  border-radius: 20px; opacity: .7;
}

/* EXTRA */
.ex { display: grid; gap: 12px; }
.e {
  display: flex; align-items: center; gap: 14px;
  padding: 14px 16px; border: 1px solid var(--bd); border-radius: 12px;
  background: #f8fafc; transition: .25s;
}
.e:hover { transform: translateY(-3px); box-shadow: 0 8px 20px rgba(37,99,235,.08); }
.e > .fa {
  width: 40px; height: 40px; flex: 0 0 40px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(37,99,235,.10), rgba(124,58,237,.08));
  color: var(--b); font-size: 16px;
}
.e > div { flex: 1; min-width: 0; }
.e strong { display: block; font-size: 14px; font-weight: 700; }
.e small { font-size: 12px; color: var(--mu); }
.mib {
  padding: 8px 16px; border: 1px solid var(--bd);
  background: var(--c); color: var(--tx);
  font-size: 12.5px; font-weight: 700; border-radius: 9px; cursor: pointer; white-space: nowrap;
}
.mib:hover { background: linear-gradient(135deg, var(--b), var(--p)); color: #fff; border-color: transparent; }

/* =====================================================
   CHILDREN
===================================================== */
.kids {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}
.kid {
  display: flex; align-items: flex-start; gap: 14px;
  padding: 16px;
  border: 1px solid var(--bd); border-radius: 14px;
  background: #f8fafc; transition: .25s;
  position: relative;
}
.kid:hover {
  transform: translateY(-4px); border-color: var(--b); background: #fff;
  box-shadow: 0 12px 26px rgba(37,99,235,.12);
}
.kid .av {
  width: 54px; height: 54px; flex: 0 0 54px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--b), var(--p));
  color: #fff; font-size: 18px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
}
.kid .av img { width: 100%; height: 100%; object-fit: cover; }
.kid .kb { flex: 1; min-width: 0; }
.kid .kb h4 {
  margin: 0 0 3px; font-size: 15px; font-weight: 800;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.kid .kb .meta {
  color: var(--mu); font-size: 12px; margin-bottom: 8px;
}
.kid .chips { display: flex; gap: 6px; flex-wrap: wrap; }
.kid .chip {
  padding: 3px 9px; border-radius: 20px;
  font-size: 10.5px; font-weight: 700;
  background: #eef2ff; color: var(--b);
  border: 1px solid rgba(37,99,235,.2);
}
.kid .chip.a { background: rgba(16,185,129,.12); color: #059669; border-color: rgba(16,185,129,.25); }
.kid .chip.m { background: rgba(124,58,237,.10); color: var(--p); border-color: rgba(124,58,237,.2); }
.kid .go {
  position: absolute; top: 12px; right: 12px;
  width: 30px; height: 30px;
  border-radius: 8px; border: 1px solid var(--bd);
  background: #fff; color: var(--b);
  display: flex; align-items: center; justify-content: center;
  text-decoration: none; font-size: 13px;
  transition: .2s;
}
.kid .go:hover { background: var(--b); color: #fff; border-color: transparent; }

/* Loading / empty / error states for kids */
.kids-state {
  padding: 32px 20px; text-align: center;
  color: var(--mu); font-size: 13.5px;
  border: 1px dashed var(--bd); border-radius: 12px;
  background: #f8fafc;
}
.kids-state i { font-size: 28px; display: block; margin-bottom: 10px; color: var(--b); opacity: .5; }

/* Error box */
.err {
  padding: 12px 14px; margin-bottom: 18px; border-radius: 10px;
  background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; font-size: 13px;
}
.err.info { background: #eff6ff; color: #1d4ed8; border-color: #bfdbfe; }

/* =====================================================
   TABLET
===================================================== */
@media (max-width: 1199px) {
  .lay { padding: 18px; gap: 18px; }
  .sb { width: 220px; min-width: 220px; flex-basis: 220px; }
  .tb { padding: 16px 18px; }
  .tt h1 { font-size: 20px; }
  .dc { padding: 20px; }
}

/* MOBILE SIDEBAR */
@media (max-width: 991px) {
  .lay { display: block; width: 100%; padding: 14px; margin-top: 88px; }
  .mn2 { width: 100%; }
  .sb {
    position: fixed; top: 0; left: 0; margin-top: 70px;
    width: 270px; max-width: 85vw; height: 100vh;
    padding: 16px 12px; border-radius: 0;
    transform: translateX(-110%); transition: transform .3s ease;
    z-index: 9999; overflow-y: auto;
  }
  .sb.open { transform: translateX(0); }
  .mb { display: flex; }
  .tb { margin-top: 10px; margin-bottom: 16px; padding: 14px 16px; gap: 12px; }
  .dc { width: 100%; padding: 18px; }
}

/* MOBILE */
@media (max-width: 768px) {
  .lay { padding: 10px; }
  .tb { padding: 12px; border-radius: 12px; }
  .mb { width: 40px; height: 40px; }
  .tt h1 { font-size: 17px; }
  .tt p { font-size: 11px; }
  .ta { gap: 7px; }
  .ib, .as { width: 38px; height: 38px; }
  .dc { padding: 14px; border-radius: 12px; }
  .dh { flex-direction: column; align-items: flex-start; gap: 12px; margin-bottom: 16px; }
  .dh h3 { font-size: 16px; }
  .da { width: 100%; }
  .bc, .bs { flex: 1; }
  .gd { grid-template-columns: 1fr; gap: 10px; }
  .fld, .fld[style*="span 2"] { grid-column: span 1 !important; width: 100%; }
  .fld { padding: 13px; }
  .fb p { font-size: 13px; }
  .fb label { font-size: 10px; }
  .e { padding: 12px; gap: 10px; }
  .e > .fa { width: 36px; height: 36px; flex-basis: 36px; }
  .e strong { font-size: 13px; }
  .e small { font-size: 11px; }
  .kids { grid-template-columns: 1fr; }
}

/* SMALL MOBILE */
@media (max-width: 480px) {
  .lay { padding: 8px; }
  .tb { padding: 10px; gap: 9px; margin-top: 6px; }
  .mb { width: 38px; height: 38px; }
  .tt h1 { font-size: 16px; }
  .tt p { display: none; }
  .ta { gap: 5px; }
  .ib, .as { width: 36px; height: 36px; }
  .ib { display: none; }
  .dc { padding: 12px; }
  .dh h3 { font-size: 15px; }
  .dh p { font-size: 11px; }
  .da { gap: 6px; }
  .bc, .bs { padding: 8px; font-size: 12px; }
  .fld { padding: 11px; gap: 9px; }
  .fi { width: 32px; height: 32px; flex-basis: 32px; font-size: 12px; }
  .fb label { font-size: 9px; }
  .fb p { font-size: 12px; }
  .e { flex-wrap: wrap; }
  .e > div { min-width: 0; }
  .mib { width: 100%; margin-top: 3px; }
  .kid .av { width: 46px; height: 46px; flex-basis: 46px; font-size: 16px; }
  .kid { padding: 13px; }
}

/* VERY SMALL MOBILE */
@media (max-width: 360px) {
  .lay { padding: 6px; }
  .tb { padding: 8px; }
  .tt h1 { font-size: 15px; }
  .dc { padding: 10px; }
  .fld { padding: 10px; }
  .fb p { font-size: 11px; }
}
      `}</style>

      <div className={`pw ${dark ? "dk" : ""}`}>
        {open && <div className="ov" onClick={() => setOpen(false)} />}

        <div className="lay">
          {/* SIDEBAR */}
          <aside className={`sb ${open ? "open" : ""}`}>
            <div className="br">
              <span className="bi">
                <i className="fa fa-graduation-cap" />
              </span>
              <div>
                <small>STUDENT SCHOOL</small>
                <strong>DARPAN</strong>
              </div>
            </div>

            <ul className="mn">
              {MENU.map(([to, ic, nm, cls]) => (
                <li key={nm}>
                  <Link to={to} className={cls} onClick={() => setOpen(false)}>
                    <i className={`fa ${ic}`} />
                    {nm}
                  </Link>
                </li>
              ))}
              <li className="dv" />
            </ul>
          </aside>

          {/* MAIN */}
          <main className="mn2">
            <header className="tb">
              <button className="mb" onClick={() => setOpen(true)} aria-label="Open Menu">
                <i className="fa fa-bars" />
              </button>

              <div className="tt">
                <h1>My Profile</h1>
                <p>Manage your personal information</p>
              </div>

              <div className="ta">
                <button className="ib">
                  <i className="fa fa-bell" />
                  <span className="dt" />
                </button>
                <div className="as">{p.name ? p.name[0] : "?"}</div>
              </div>
            </header>

            {/* PROFILE CARD */}
            <section className="dc">
              {error && <div className="err">⚠️ {error}</div>}

              <div className="dh">
                <div>
                  <h3>Personal Information</h3>
                  <p>Your account details</p>
                </div>

                {!loading && (
                  <div className="da">
                    {edit ? (
                      <>
                        <button className="bc" onClick={cancel}>
                          <i className="fa fa-times" /> Cancel
                        </button>
                        <button className="bs" onClick={save}>
                          <i className="fa fa-check" /> Save
                        </button>
                      </>
                    ) : (
                      <button
                        className="bs"
                        onClick={() => {
                          setT(p);
                          setEdit(true);
                        }}
                      >
                        <i className="fa fa-pencil" /> Edit
                      </button>
                    )}
                  </div>
                )}
              </div>

              {loading ? (
                <div style={{ textAlign: "center", padding: "40px 20px", color: "#64748b", fontSize: 14 }}>
                  Loading profile...
                </div>
              ) : (
                <div className="gd">
                  <F i="fa-user" l="Name" n="name" v={t.name} />
                  <F i="fa-envelope-o" l="Email" n="email" v={t.email} dis />
                  <F i="fa-phone" l="Phone" n="phone" v={t.phone} />
                  <F i="fa-shield" l="Role" n="role" v={t.role} dis />
                  <F i="fa-building-o" l="School" n="school" v={t.school} full dis />
                  <F i="fa-map-marker" l="City" n="city" v={t.city} />
                  <F i="fa-calendar" l="Joining" n="joiningDate" v={t.joiningDate} dis />
                </div>
              )}
            </section>

            {/* =====================================================
                MY CHILDREN
            ===================================================== */}
            <section className="dc">
              <div className="dh">
                <div>
                  <h3>
                    <i className="fa fa-child" style={{ color: "var(--b)", marginRight: 8 }} />
                    My Children
                  </h3>
                  <p>
                    {loadingKids
                      ? "Loading..."
                      : `${children.length} student${children.length !== 1 ? "s" : ""} linked to your account`}
                  </p>
                </div>
              </div>

              {kidsError && <div className="err">⚠️ {kidsError}</div>}

              {loadingKids ? (
                <div className="kids-state">
                  <i className="fa fa-spinner fa-spin" />
                  Loading children...
                </div>
              ) : children.length === 0 ? (
                <div className="kids-state">
                  <i className="fa fa-users" />
                  No children linked to this account yet.
                </div>
              ) : (
                <div className="kids">
                  {children.map((c) => {
                    const initials = (c.name || "?")
                      .split(" ")
                      .map((x) => x[0])
                      .join("")
                      .slice(0, 2)
                      .toUpperCase();
                    const clsLabel = c.section
                      ? `${c.cls}-${c.section}`
                      : c.cls;

                    return (
                      <div className="kid" key={c.id}>
                        <div className="av">
                          {c.photo ? (
                            <img src={c.photo} alt={c.name} />
                          ) : (
                            initials
                          )}
                        </div>

                        <div className="kb">
                          <h4 title={c.name}>{c.name}</h4>
                          <div className="meta">
                            <i className="fa fa-id-badge" /> {c.id || "-"}
                          </div>
                          <div className="chips">
                            <span className="chip">
                              <i className="fa fa-graduation-cap" /> {clsLabel}
                            </span>
                            <span className="chip m">
                              <i className="fa fa-list-ol" /> Roll {c.roll}
                            </span>
                            <span className={`chip ${c.status === "Active" ? "a" : ""}`}>
                              {c.status}
                            </span>
                          </div>
                        </div>

                        <Link
                          to={`/Student_Report/${c.id}`}
                          className="go"
                          title="View report"
                        >
                          <i className="fa fa-arrow-right" />
                        </Link>
                      </div>
                    );
                  })}
                </div>
              )}
            </section>

            {/* CHANGE PASSWORD */}
            <section className="dc">
              <div className="dh">
                <div>
                  <h3>Security</h3>
                  <p>Manage your account security</p>
                </div>
              </div>

              <div className="ex">
                <div className="e">
                  <i className="fa fa-lock" />
                  <div>
                    <strong>Change Password</strong>
                    <small>Update your password</small>
                  </div>
                  <button className="mib">Update</button>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
}